// SparkX AI License Config — AmanLifeStyleBD
// এই ফাইলটি সরাসরি .gitignore তে যোগ করুন, public repo তে commit করবেন না।

export const LICENSE_CONFIG = {
  apiUrl: 'https://guard-server.sparkx-ai.shop/api/v1/verify-license',
  apiKey: 'lic_live_1f7f3c667cbc63df79dd9c142f1fa0b299de3f895fad0d69',
  domain: 'amanlifestylebd.com',
  supportWhatsApp: '01516585709',
};
